<div class="printable">
  <authority-labs-base-certificate-details
    [order]="order"
    [project]="project"
    [subProject]="subProject"
    [company]="company"
    [contact]="contact"
    [assignee]="assignee"
    [approval]="approval"
    [inspection]="inspection"
    [systemDescription]="'מערכת אוטומטית לכיבוי בלוחות חשמל באמצעות אירוסול'"
  ></authority-labs-base-certificate-details>

  <div class="page-break"></div>

  <authority-labs-aerosol-shutdown-test-results
    [inspection]="inspection.inspectionAerosolShutdown"
  >
  </authority-labs-aerosol-shutdown-test-results>

  <p style="text-align: center">
    <strong style="font-size: 5pt; position: relative; top: -5px"
      >&#10033;</strong
    >
    <strong style="font-size: 14pt">סוף תעודת בדיקה</strong>
    <strong style="font-size: 5pt; position: relative; top: -5px"
      >&#10033;</strong
    >
  </p>
</div>
